<template>
  <v-card color="#FFFBDA">
    <v-container>
      <div class="my-4 text-h5 font-weight-bold">日誌紀錄月報表匯出</div>

      <!-- 選擇月份 -->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇月份</div>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            dense
            outlined
            v-model="formattedDate"
            readonly
            v-bind="attrs"
            v-on="on"
            hide-details="true"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="selectedDate"
          type="month"
          locale="zh-TW"
          @input="menu = false"
        ></v-date-picker>
      </v-menu>

      <!-- 選擇機構 -->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇機構</div>
      <v-select
        dense
        outlined
        v-model="selectedInstitution"
        :items="institutionOptions"
        hide-details="true"
      ></v-select>

      <!-- 選擇個案（依機構過濾） -->
      <div class="my-2 text-h6 font-weight-bold blue--text">選擇個案</div>
      <v-autocomplete
        dense
        outlined
        v-model="selectedCases"
        :items="filteredCaseOptions"
        item-text="name"
        item-value="case_num"
        multiple
        chips
        deletable-chips
        clearable
        :loading="loading"
        :disabled="loading"
        no-data-text="無"
        hide-details="true"
      >
        <template v-slot:selection="{ item }">
          <v-chip
            class="white--text"
            color="#6A80B9"
            close
            @click:close="removeChip(item.case_num)"
          >
            {{ item.name }}
          </v-chip>
        </template>
      </v-autocomplete>

      <v-btn color="#F6C794" class="mt-4 font-weight-bold" @click="exportReport"> 匯出報表 </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  data() {
    return {
      menu: false,
      selectedDate: moment().format('YYYY-MM'),
      selectedInstitution: '全部', // 預設機構
      institutionOptions: [], // 機構列表
      selectedCases: [],
      caseOptions: [],
      loading: false,
      downloading: false,
    }
  },
  computed: {
    formattedDate() {
      return this.selectedDate
    },
    // 依機構過濾個案選項
    filteredCaseOptions() {
      return this.caseOptions.filter((opt) => {
        // 「全部」 always 顯示
        if (opt.case_num === 'all') return true
        if (this.selectedInstitution === '全部') return true
        return Array.isArray(opt.institution) && opt.institution.includes(this.selectedInstitution)
      })
    },
  },
  methods: {
    async fetchCaseOptions() {
      this.loading = true
      try {
        const response = await axios.get('/api/attendance/name_corresponding/')
        const data = response.data

        // 原始個案清單
        this.caseOptions = data

        // 建立機構選單（去重）
        const instSet = new Set()
        data.forEach((item) => {
          if (Array.isArray(item.institution)) {
            item.institution.forEach((inst) => instSet.add(inst))
          }
        })
        this.institutionOptions = ['全部', ...Array.from(instSet)]

        // 在個案清單前加入「全部」
        this.caseOptions.unshift({ name: '全部', case_num: 'all' })
      } catch (error) {
        console.error('Error:', error)
      } finally {
        this.loading = false
      }
    },
    async exportReport() {
      const payloadCases = this.selectedCases.filter((c) => c !== 'all')
      if (!payloadCases.length) {
        alert('請選擇至少一個個案')
        return
      }
      this.downloading = true
      const requestBody = {
        cases: payloadCases,
        month: this.selectedDate,
        timezone: 'Asia/Taipei',
      }
      try {
        const response = await axios.post('/api/journal/monthly_report/', requestBody, {
          responseType: 'blob',
        })
        const fileName = `${this.selectedDate.replace('-', '')}_service_record.zip`
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(link)
        this.resetSelections()
      } catch (error) {
        console.error('匯出報表失敗:', error)
        alert('匯出失敗，請稍後再試！')
      } finally {
        this.downloading = false
      }
    },
    removeChip(caseNum) {
      this.selectedCases = this.selectedCases.filter((c) => c !== caseNum)
    },
    resetSelections() {
      this.selectedDate = moment().format('YYYY-MM')
      this.selectedInstitution = '全部'
      this.selectedCases = []
    },
  },
  watch: {
    selectedCases(newVal, oldVal) {
      // 勾選「全部」時，全部打勾
      if (newVal.includes('all') && !oldVal.includes('all')) {
        this.selectedCases = this.caseOptions.map((opt) => opt.case_num)
      }
      // 取消「全部」時，清空
      if (!newVal.includes('all') && oldVal.includes('all')) {
        this.selectedCases = []
      }
    },
  },
  mounted() {
    this.fetchCaseOptions()
  },
}
</script>
